import styled, { css } from 'styled-components';
import { ICON_SIZES } from '../../../../icon';
import Typography from '../../../../typography';
import { getIconUrl, pxToRem } from '../../../../../design-tokens/style-utilities';
const ARROW_POSITION_RIGHT = -5;
/**
 * BusStopItem
 */
export const busStopItemStyles = ({ theme, $mode }) => css `
	display: none;
	padding: ${pxToRem(theme.spacing['50'])} ${pxToRem(theme.spacing['200'])};

	${$mode === 'active' &&
    css `
		display: block;
		color: ${theme.colors.action.underlinePaginationActive};
	`}

	${$mode === 'disabled' &&
    css `
		color: ${theme.colors.medium.textInactive};
	`} @media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		flex: 1;
		display: block;
		border-bottom: ${theme.borderWidth['1']}px solid ${theme.colors.base.underlinePagination};

		${$mode === 'active' &&
    css `
			border-color: ${theme.colors.action.underlinePaginationActive};
		`}
		${$mode === 'disabled' &&
    css `
			border-color: ${theme.colors.medium.underlinePaginationInactive};
		`}
    &:not(:last-of-type) {
			position: relative;

			&::after {
				content: '';
				position: absolute;
				right: ${pxToRem(ARROW_POSITION_RIGHT)};
				bottom: -${pxToRem(ICON_SIZES.md / 2)};
				mask: url('${getIconUrl('chevron-right', 'ui')}') no-repeat center right;
				height: ${pxToRem(ICON_SIZES.md)};
				width: ${pxToRem(ICON_SIZES.md)};
				background-color: currentcolor;
			}
		}
	}
`;
export const StyledBusStopItem = styled.li `
	${busStopItemStyles}
`;
/**
 * The idea came from https://inclusive-components.design/tooltips-toggletips/
 */
export const busStopHiddenTextStyles = () => `
	position: absolute;
	clip-path: inset(100%);
	clip: rect(1px, 1px, 1px, 1px);
	height: 1px;
	width: 1px;
	overflow: hidden;
	white-space: nowrap;
`;
export const StyledBusStopAssistiveText = styled.span `
	${busStopHiddenTextStyles}
`;
/**
 * BusStopItem Anchor
 */
export const busStopItemAnchorStyles = ({ theme, $step, $total, }) => css `
	display: inline-block;
	text-decoration: none;
	color: inherit;

	&::before {
		content: 'Stap ${$step} van ${$total}: ';
		color: ${theme.colors.base.textLabel};
	}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		width: 100%;
		text-align: center;

		&:hover {
			color: inherit;
		}

		&[href]:hover {
			color: ${theme.colors.highlight.textHover};
		}

		&::before {
			content: '${$step}. ';
			color: inherit;
		}
	}
`;
export const StyledBusStopItemAnchor = styled(Typography).attrs({
    variant: 'label-title',
}) `
	${busStopItemAnchorStyles}
`;
